import { Link } from "react-router-dom";

const LandingFooter = () => {
  return (
    <footer className="relative bg-[#0A0A0F] border-t border-white/[0.05]">
      <div className="container mx-auto px-4 py-16">
        <div className="grid gap-12 lg:grid-cols-5">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="text-2xl font-bold text-white tracking-tight">
                B<span className="text-[#F59E0B]">8</span>ild
              </span>
            </Link>
            <p className="text-white/40 text-sm max-w-sm mb-8 leading-relaxed">
              La solution de pilotage de rentabilité pour les professionnels du BTP. Conçu en France, pour les artisans et PME du bâtiment.
            </p>

            {/* Trust badges */}
            <div className="flex flex-wrap gap-3">
              {[
                { emoji: "🇫🇷", text: "Made in France" },
                { emoji: "🔒", text: "RGPD" },
                { emoji: "☁️", text: "Hébergé en France" },
              ].map((badge, i) => (
                <div
                  key={i}
                  className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/[0.03] border border-white/[0.05] text-xs text-white/50"
                >
                  <span>{badge.emoji}</span>
                  <span>{badge.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Links - Product */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-6">Produit</h4>
            <ul className="space-y-4">
              {[
                { label: "Fonctionnalités", href: "/product" },
                { label: "Tarifs", href: "/pricing" },
                { label: "Blog", href: "/blog" },
                { label: "Qui sommes-nous", href: "/qui-sommes-nous" },
                { label: "FAQ", href: "/#faq", isHash: true },
              ].map((link) => (
                <li key={link.label}>
                  {"isHash" in link ? (
                    <a
                      href={link.href}
                      onClick={(e) => {
                        if (window.location.pathname === "/") {
                          e.preventDefault();
                          document.getElementById("faq")?.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                      className="text-sm text-white/40 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-sm text-white/40 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Links - Votre profil */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-6">Par métier</h4>
            <ul className="space-y-4">
              {[
                { label: "Tous les métiers", href: "/use-cases" },
                { label: "Électricien", href: "/use-cases/electricien" },
                { label: "Plombier", href: "/use-cases/plombier" },
                { label: "Maçon", href: "/use-cases/macon" },
                { label: "Peintre", href: "/use-cases/peintre" },
                { label: "Couvreur", href: "/use-cases/couvreur" },
                { label: "Multi-corps", href: "/use-cases/multi-corps" },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/40 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links - Legal */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-6">Légal</h4>
            <ul className="space-y-4">
              {[
                { label: "CGU", href: "/cgu" },
                { label: "CGV", href: "/cgv" },
                { label: "Mentions légales", href: "/mentions-legales" },
                { label: "Confidentialité", href: "/confidentialite" },
                { label: "Contact", href: "/contact" },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/40 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.05] mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/30">
              © {new Date().getFullYear()} B8ild. Tous droits réservés.
            </p>

            {/* Social links */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/b8ild"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/30 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
